import React from 'react';

import LoadingBar from './LoadingBar';
import PluginList from './PluginList';
import PluginDev from './PluginDev';
import CustomButton from './CustomButton';
import {Route, Switch, Redirect} from 'react-router-dom';

import './theme.css';

export default class Plugins extends React.Component {
  constructor(props/*fl: flamelinkApp*/)
  {
    super(props);

    this.state = {data: undefined};
    let that = this;
    this.props.fl.content.get('plugins',
      //{fields: [ 'name', 'description'],}
    )
    .then(rs => {
      let plugins = [];
      Object.keys(rs).forEach(iprop => {plugins.push(rs[iprop]);});
      that.setState({data: plugins});
      let imgpromises = [];
      let pcnt=0;
      for(let ip=0; ip < plugins.length; ip++)
      {
        imgpromises[pcnt++] = new Promise((resolve, reject)=>{
          if(plugins[ip].img1)
            this.props.fl.storage.getURL(plugins[ip].img1[0]).then(
              img1res=> {plugins[ip].img1 = img1res; that.setState({data: plugins}); resolve("nice");}).catch(err => reject(err));
          else resolve("nice");
        });
        imgpromises[pcnt++] = new Promise((resolve, reject)=>{
          if(plugins[ip].img2)
            this.props.fl.storage.getURL(plugins[ip].img2[0]).then(
              img2res=> {plugins[ip].img2 = img2res; that.setState({data: plugins}); resolve("nice");}).catch(err => reject(err));
          else resolve("nice");
        });
      }
      Promise.all(imgpromises).then(()=>{
        that.setState({data: plugins});
      }).catch(err => console.error(err));
    })
    .catch(err => console.error(err));

  }

  render() {
    return (
          <div>
            <div className="pluginList">
              <h1>IFS plugins</h1>
              <h2>Plugins for IFS flame editors (Apophysis7X, Chaotica)</h2>
            </div>
            <Switch>
              <Route exact path='/plugins/development' component={()=> <PluginDev/> }/>
              <Route component={()=> <div style={{textAlign:'center', margin: '30px'}}><CustomButton text="Development" nav url="/plugins/development"/></div> }/>
            </Switch>
            {this.state && this.state.data ? <PluginList data={this.state.data} /> : <LoadingBar/> }
          </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/Component/Plugins.js